import { render, staticRenderFns } from "./jibingfuzhu.vue?vue&type=template&id=785152ed&"
import script from "./jibingfuzhu.vue?vue&type=script&lang=ts&"
export * from "./jibingfuzhu.vue?vue&type=script&lang=ts&"
import style0 from "./jibingfuzhu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports